import api from "../../api/api";
import { useState, useEffect } from "react";
import Last from "../../Components/Reports/Last";
import Discrease from "../../Components/Stats/Discrease";
import Increase from "../../Components/Stats/Increase";
import State from "../../Components/Stats/State";
import DernieresReservation from "../../Components/Tableaux/10Reserv";
import ListePlaintes from "../../Components/Tableaux/listePlaintes";
import DerniersPaiement from "../../Components/Tableaux/10Payments";
import DernieresAnnonces from "../../Components/Tableaux/10Annonces";
import Plaintes from "../Plaintes/plaintes";
import TablePlaintes from "../../Components/Tableaux/Plaintes";
import DerniereTransaction from "../../Components/Tableaux/10Transaction";
import StateContain from './../../Components/Stats/StateContain';
import LastCus from './../../Components/Tableaux/10Clients';
import { MyContext } from "../../Components/Context";

const Dash = ({ actifItem, setActifItem }) => {
    const [currentStats, setCurrentStats] = useState({
        clientCount: 0,
        announceCount: 0,
        paiementCount: 0,
        bookingCount: 0,
        ownerCount: 0,
        complaintCount: 0,
    });

    const [previousStats, setPreviousStats] = useState({
        clientCount: 0,
        announceCount: 0,
        paiementCount: 0,
        bookingCount: 0,
        ownerCount: 0,
        complaintCount: 0,
    });

    const [latest, setLatest] = useState({})
    const [numbers, setNumbers] = useState(null)
    const [all, setAll] = useState(null)

    
    useEffect(() => {
        const getStatistics = async () => {
            try {
                const response = await api.get('/getStatistics');
                
                setPreviousStats(response.data.previousStats);
                setCurrentStats(response.data.currentStats);
                setLatest(response.data.latestData)
                setNumbers(response.data.number)
                setAll(response.data.all)
                                
            } catch (err) {
                
                console.error('Erreur lors de la récupération des statistiques :', err);
            }
        };

        getStatistics();
        const interval = setInterval(getStatistics, 60000); // Met à jour toutes les minutes
        return () => clearInterval(interval); // Nettoie l'intervalle lors du démontage du composant
    }, []);

    const calculateChange = (current, previous) => {
        if (previous === 0) {
            return current === 0 ? '0%' : '+100%'; // Affiche +100% si current > 0 et 0% si current est aussi 0
        }
        
        const change = ((current - previous) / previous) * 100;
        
        return `${change > 0 ? '+' : ''}${change.toFixed(2)}%`;
    };

    return (
        <div className="grid h-screen grid-cols-12 gap-4 px-4 ">
            <div className="col-span-12 lg:col-span-8">
                <p className="py-10 text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">Statistiques</p>
                <div className="grid gap-4 lg:gap-8 md:grid-cols-12 animate-fade-up">
                    <div className="col-span-6">
                        {currentStats.clientCount > previousStats.clientCount ? (
                            <Increase 
                                nom={'Clients'} 
                                value={currentStats.clientCount} 
                                changeValue={calculateChange(currentStats.clientCount, previousStats.clientCount)} 
                                className={'relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5'} 
                            />
                        ) : (
                            <Discrease 
                                nom={'Clients'} 
                                value={currentStats.clientCount} 
                                changeValue={calculateChange(currentStats.clientCount, previousStats.clientCount)} 
                                className={"relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5"} 
                            />
                        )}
                        {currentStats.announceCount > previousStats.announceCount ? (
                            <Increase 
                                nom={'Annonces'} 
                                value={currentStats.announceCount} 
                                changeValue={calculateChange(currentStats.announceCount, previousStats.announceCount)} 
                                className={'relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5'} 
                            />
                        ) : (
                            <Discrease 
                                nom={'Annonces'} 
                                value={currentStats.announceCount} 
                                changeValue={calculateChange(currentStats.announceCount, previousStats.announceCount)} 
                                className={"relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5"} 
                            />
                        )}
                        {currentStats.paiementCount > previousStats.paiementCount ? (
                            <Increase 
                                nom={'Paiements'} 
                                value={currentStats.paiementCount} 
                                changeValue={calculateChange(currentStats.paiementCount, previousStats.paiementCount)} 
                                className={'relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5'} 
                            />
                        ) : (
                            <Discrease 
                                nom={'Paiements'} 
                                value={currentStats.paiementCount} 
                                changeValue={calculateChange(currentStats.paiementCount, previousStats.paiementCount)} 
                                className={"relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5"} 
                            />
                        )}
                    </div>
                    <div className="col-span-6">
                        {currentStats.bookingCount > previousStats.bookingCount ? (
                            <Increase 
                                nom={'Reservations'} 
                                value={currentStats.bookingCount} 
                                changeValue={calculateChange(currentStats.bookingCount, previousStats.bookingCount)} 
                                className={'relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5'} 
                            />
                        ) : (
                            <Discrease 
                                nom={'Reservations'} 
                                value={currentStats.bookingCount} 
                                changeValue={calculateChange(currentStats.bookingCount, previousStats.bookingCount)} 
                                className={"relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5"} 
                            />
                        )}
                        {currentStats.ownerCount > previousStats.ownerCount ? (
                            <Increase 
                                nom={'Propriétaires'} 
                                value={currentStats.ownerCount} 
                                changeValue={calculateChange(currentStats.ownerCount, previousStats.ownerCount)} 
                                className={'relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5'} 
                            />
                        ) : (
                            <Discrease 
                                nom={'Propriétaires'} 
                                value={currentStats.ownerCount} 
                                changeValue={calculateChange(currentStats.ownerCount, previousStats.ownerCount)} 
                                className={"relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5"} 
                            />
                        )}
                        {currentStats.complaintCount > previousStats.complaintCount ? (
                            <Increase 
                                nom={'Plaintes'} 
                                value={currentStats.complaintCount} 
                                changeValue={calculateChange(currentStats.complaintCount, previousStats.complaintCount)} 
                                className={'relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5'} 
                            />
                        ) : (
                            <Discrease 
                                nom={'Plaintes'} 
                                value={currentStats.complaintCount} 
                                changeValue={calculateChange(currentStats.complaintCount, previousStats.complaintCount)} 
                                className={"relative p-6 rounded-2xl bg-white shadow dark:bg-gray-800 mb-5"} 
                            />
                        )}
                    </div>
                </div>
            </div>


            <div className="col-span-12 py-10">
                <p className="text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">Reservations</p>
                {all && <div className="flex flex-row flex-wrap gap-10 p-8 px-10 py-10">
                    <StateContain value={all.reservations.filter(item => item.status === 2)} state={'res'} name={'En cours'} />
                    <StateContain value={all.reservations.filter(item => (item.status === -1 || item.status === -2))} state={'echec'} name={'Echouée'} />
                    <StateContain value={all.reservations.filter(item => item.status === 0)} state={'inWainting'} name={'En attente'} />
                    <StateContain value={all.reservations.filter(item => item.status === 3)} state={'ended'} name={'Terminée'} />
                </div>}
            </div>
            

            {
                latest.lastCustomer &&
                <div className="col-span-12 p-8 px-10 py-10 ">
                    <LastCus data={latest.lastCustomer}/>
                </div>
            }
            
            {latest.lastComplain && 
                <div className="col-span-12 p-8 px-10 py-10 ">
                    <TablePlaintes data={latest.lastComplain}/>
                </div>
            }
            
            {latest.lastBooking &&
                <div className="col-span-12 p-8 px-10 py-10">
                    <DernieresReservation data={latest.lastBooking}/>
                </div>
            }

            
            {latest.lastPay &&
                <div className="col-span-12 p-8 px-10 py-10">
                    <DerniersPaiement data={latest.lastPay}/>
                </div>
            }
            
            
            {latest.lastAnnonce && 
                <div className="col-span-12 p-8 px-10 py-10">
                    <DernieresAnnonces data={latest.lastAnnonce}/>
                </div>
            }

            {latest.lastTransaction &&
               <div className="col-span-12 p-8 px-10 py-10">
                    <DerniereTransaction data={latest.lastTransaction}/>
                </div> 
            }
        </div>
    );
};

export default Dash;
